// extracted by mini-css-extract-plugin
export var centerText = "_bm-8";
export var container = "_bm-0";
export var doughnutContainer = "_bm-7";
export var legend = "_bm-a";
export var legendItemColorDisplay = "_bm-b";
export var legendItemLabel = "_bm-d";
export var legendItemValue = "_bm-c";
export var lg = "_bm-5";
export var maxWidth = "_bm-9";
export var md = "_bm-4";
export var responsive = "_bm-6";
export var sm = "_bm-3";
export var xs = "_bm-2";
export var xxs = "_bm-1";